import React from 'react'
import ListCardComponentPokemon from '../../Components/ListCardComponentPokemon/ListCardComponentPokemon'
import ListCardAdminComponentPokemon from '../../Components/ListCardComponentPokemon/ListCardAdminComponentPokemon'
import { Inventary } from '../../Models/Inventary'

interface Props{
  onClickIventary?: (iventary:Inventary) => void
}
const CardsAdmin = ({onClickIventary}:Props) => {
  return (
    // <div className='layout-page layout-cardPage'>


      <div className='shopContainer_body'>
        <ListCardAdminComponentPokemon onClickIventary={onClickIventary} type='inventary' subType='Private' hasPrice hasCart  />

      </div>


    // </div>
  )
}

export default CardsAdmin